var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMembershipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22482_6331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.3898 12.2479C10.7523 12.2479 12.6675 10.3433 12.6675 7.99382C12.6675 5.64436 10.7523 3.73975 8.3898 3.73975C6.02731 3.73975 4.11209 5.64436 4.11209 7.99382C4.11209 10.3433 6.02731 12.2479 8.3898 12.2479Z",
    fill: "url(#paint0_linear_22482_6331)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3505 17.5023C15.3684 16.4402 14.1512 15.5786 13.2059 15.0018C11.7883 14.1982 10.1154 13.7604 8.38985 13.7604C6.07634 13.7604 3.8576 14.5473 2.22171 15.9478C1.2561 16.7746 0.54025 17.7751 0.115747 18.8636C-0.369898 20.1089 0.745486 21.2287 2.07613 21.2287H14.7036C14.8175 21.2287 14.9298 21.2205 15.0397 21.2047H18.0603C18.082 19.8597 17.3703 18.6051 16.3505 17.5023Z",
    fill: "url(#paint1_linear_22482_6331)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8445 13.3465C18.754 13.3465 20.302 11.7986 20.302 9.88909C20.302 7.9796 18.754 6.43164 16.8445 6.43164C14.935 6.43164 13.3871 7.9796 13.3871 9.88909C13.3871 11.7986 14.935 13.3465 16.8445 13.3465Z",
    fill: "url(#paint2_linear_22482_6331)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4329 14.7925C15.142 14.611 15.8828 14.5169 16.6337 14.5169C18.6555 14.5169 20.6118 15.2001 22.0687 16.441C22.7626 17.032 23.3694 17.6371 23.7824 18.4967C23.9685 18.8841 24.0485 19.2882 23.9701 19.6833C23.8908 20.0834 23.6646 20.3958 23.3824 20.6213C22.8471 21.0491 22.0698 21.2049 21.3498 21.2049H18.8235C18.8466 19.5268 17.951 18.0398 16.861 16.8611C16.1066 16.0454 15.2329 15.3465 14.4329 14.7925Z",
    fill: "url(#paint3_linear_22482_6331)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22482_6331",
    x1: -0.00012207,
    y1: 12.4842,
    x2: 18.0608,
    y2: 12.4842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B71F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FB5F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22482_6331",
    x1: -0.00012207,
    y1: 12.4842,
    x2: 18.0608,
    y2: 12.4842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B71F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FB5F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_22482_6331",
    x1: 13.3871,
    y1: 13.8183,
    x2: 24,
    y2: 13.8183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1CBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBE2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_22482_6331",
    x1: 13.3871,
    y1: 13.8183,
    x2: 24,
    y2: 13.8183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1CBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBE2FD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22482_6331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.484375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembershipIcon);
export default __webpack_public_path__ + "static/media/membership-icon.7d3de65253c5f0d14a9b66acace84b90.svg";
export { ForwardRef as ReactComponent };